export var UserType = /*#__PURE__*/function (UserType) {
  UserType[UserType["Unknown"] = 0] = "Unknown";
  UserType[UserType["Client"] = 1] = "Client";
  UserType[UserType["External"] = 2] = "External";
  UserType[UserType["Bot"] = 3] = "Bot";
  UserType[UserType["Operator"] = 4] = "Operator";
  return UserType;
}({});
export var SessionChannel = /*#__PURE__*/function (SessionChannel) {
  SessionChannel[SessionChannel["Unknown"] = 0] = "Unknown";
  SessionChannel[SessionChannel["Web"] = 1] = "Web";
  SessionChannel[SessionChannel["App"] = 2] = "App";
  return SessionChannel;
}({});
export var SessionStatus = /*#__PURE__*/function (SessionStatus) {
  SessionStatus[SessionStatus["Unknown"] = 0] = "Unknown";
  SessionStatus[SessionStatus["Created"] = 1] = "Created";
  SessionStatus[SessionStatus["Started"] = 2] = "Started";
  SessionStatus[SessionStatus["Enqueued"] = 3] = "Enqueued";
  SessionStatus[SessionStatus["Finished"] = 4] = "Finished";
  return SessionStatus;
}({});
export var OperationResultCode = /*#__PURE__*/function (OperationResultCode) {
  OperationResultCode[OperationResultCode["success"] = 1] = "success";
  OperationResultCode[OperationResultCode["error"] = 2] = "error";
  return OperationResultCode;
}({});
export var MessageStatus = /*#__PURE__*/function (MessageStatus) {
  MessageStatus[MessageStatus["sent"] = 1] = "sent";
  MessageStatus[MessageStatus["delivered"] = 2] = "delivered";
  MessageStatus[MessageStatus["failed"] = 3] = "failed";
  MessageStatus[MessageStatus["refresh"] = 4] = "refresh";
  MessageStatus[MessageStatus["download"] = 5] = "download";
  return MessageStatus;
}({});
export var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType[MessageType["Unknown"] = 0] = "Unknown";
  MessageType[MessageType["Text"] = 1] = "Text";
  MessageType[MessageType["File"] = 2] = "File";
  MessageType[MessageType["Contact"] = 3] = "Contact";
  MessageType[MessageType["Geolocation"] = 4] = "Geolocation";
  MessageType[MessageType["WIDGET"] = 5] = "WIDGET";
  MessageType[MessageType["CAPTCHA"] = 6] = "CAPTCHA";
  MessageType[MessageType["Button"] = 9] = "Button";
  MessageType[MessageType["FileDoc"] = 10] = "FileDoc";
  MessageType[MessageType["Img"] = 11] = "Img";
  MessageType[MessageType["Link"] = 12] = "Link";
  return MessageType;
}({});